import React from "react";
import { Link } from "react-router-dom";

import { auth } from "../../firebase/firebase.utils";

import { connect } from "react-redux";

// import CartIcon from "../../components/cart-icon/cart-icon.component";
// import CartDropdown from "../../components/cart-dropdown/cart-dopdown.component";

import "./header.styles.scss";

const Header = ({ currentUser, hidden }) => (
  <div className="header">
    <div className="options">
      {/* <Link className="option" to="/shop">
        SHOP
      </Link> */}
      {currentUser ? (
        <Link className="option" to="/">
          Trang chủ
        </Link>
      ) : null}
      {currentUser ? (
        <Link className="option" to="/add-new" type="new">
          Tạo mới
        </Link>
      ) : null}
      {currentUser ? (
        <div className="option" onClick={() => auth.signOut()}>
          <Link to="/">
            Đăng xuất
          </Link>
        </div>
      ) : null}
    </div>
  </div>
);

const mapStateToProps = ({ user: { currentUser }, cart: { hidden } }) => ({
  currentUser,
  hidden,
});
export default connect(mapStateToProps)(Header);
